import dayjs, { type Dayjs } from 'dayjs';

export const OPERATION_DATETIME_API_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const OPERATION_DATETIME_UI_FORMAT = 'DD.MM.YYYY HH:mm';

export const toOperationDateTime = (
  value: Dayjs | null
): string | undefined => {
  if (!value) return undefined;
  return value.format(OPERATION_DATETIME_API_FORMAT);
};

export const fromOperationDateTime = (
  value: string | null | undefined
): Dayjs | undefined => {
  if (!value) return undefined;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : undefined;
};
